/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Summerocctemperaturesetpoint3Inputs */



/**
* | output |
* | --- |
* | "Summer occupied heating setpoint" |
*
* @param {Ahu_History_Key_Summerocctemperaturesetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_summerocctemperaturesetpoint3 = /** @type {((inputs?: Ahu_History_Key_Summerocctemperaturesetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Summerocctemperaturesetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer occupied heating setpoint")
	return /** @type {LocalizedString} */ ("Consigne chaud occupation été")
});
export { ahu_history_key_summerocctemperaturesetpoint3 as "ahu_history_key_summerOccTemperatureSetpoint" }